// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Trigger: sutil resaltado al abrir, sin el naranja de "activo" */
.UserMenu_trigger__O-RR4 {
  border: none;
  background: transparent;
  text-align: left;
  font-family: var(--font-sans);
}
.UserMenu_triggerOpen__cQW7C {
  background: color-mix(in srgb, var(--dylo-teal-700) 12%, transparent);
  color: var(--dylo-ink);
}

.UserMenu_menu__NCb6M {
  position: fixed;
  z-index: 1200;
  width: 244px;
  padding: 8px;
  background: var(--dylo-surface);
  border: 1px solid var(--dylo-surface-border);
  border-radius: 14px;
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.28);
  transform-origin: bottom left;
  animation: UserMenu_user-menu-in__fPoiv 0.18s cubic-bezier(0.16, 1, 0.3, 1) both;
}

@keyframes UserMenu_user-menu-in__fPoiv {
  from { opacity: 0; transform: translateY(6px) scale(0.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.UserMenu_identity__5BqXd {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 8px 8px 10px;
}
.UserMenu_avatar__8lvQg {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--dylo-teal-700);
  color: #fff;
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 700;
}
.UserMenu_identityText__4czOS {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.UserMenu_name__HqhSc {
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 700;
  color: var(--dylo-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.UserMenu_email__qYNcy {
  font-family: var(--font-sans);
  font-size: 12px;
  color: var(--dylo-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.UserMenu_divider__e0mBG {
  height: 1px;
  background: var(--dylo-line);
  margin: 4px 4px 6px;
}

.UserMenu_action__rWYOY {
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  padding: 9px 10px;
  border: none;
  background: transparent;
  color: var(--dylo-text);
  font-family: var(--font-sans);
  font-size: 13.5px;
  font-weight: 500;
  text-align: left;
  border-radius: 9px;
  cursor: pointer;
  transition: background 0.14s ease, color 0.14s ease, transform 0.14s ease;
}
/*
 * Globo de novedades sin leer.
 *
 * 🔑 \`margin-left: auto\` lo empuja al borde derecho del renglón sin necesitar una rejilla: el resto del menú son
 * renglones de icono + texto, y meter una tercera columna solo por esto cambiaría los cuatro.
 *
 * ⚠️ Lleva NUMERO y no un punto: un punto no dice cuántas, y obliga a abrir para saber si vale la pena.
 */
.UserMenu_badge__4RTVQ {
  margin-left: auto;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--dylo-teal-700);
  color: #fff;
  font-size: 10.5px;
  font-weight: 700;
  line-height: 1;
}

.UserMenu_action__rWYOY svg {
  flex-shrink: 0;
  transition: transform 0.16s ease;
}
.UserMenu_action__rWYOY:hover {
  background: color-mix(in srgb, var(--dylo-teal-700) 12%, transparent);
  color: var(--dylo-ink);
}
.UserMenu_action__rWYOY:hover svg {
  transform: scale(1.12);
}
.UserMenu_danger__2cLF9:hover {
  background: color-mix(in srgb, var(--dylo-danger) 14%, transparent);
  color: var(--dylo-danger);
}

@media (prefers-reduced-motion: reduce) {
  .UserMenu_menu__NCb6M { animation: none; }
  .UserMenu_action__rWYOY, .UserMenu_action__rWYOY svg { transition: none; }
}

/* ============================================================
   Interruptor de la vista de Developer
   ============================================================
   Único renglón del menú con colores propios. No hereda el verde del bloque del
   sidebar por accidente: se declara aquí porque el menú se dibuja en un **portal**
   (\`document.body\`), así que está fuera del árbol de \`.devBlock\` y no heredaría nada. */

.UserMenu_devToggle__yGmvo {
  --matrix-green: #39ff88;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}
.UserMenu_devToggle__yGmvo svg {
  color: var(--matrix-green);
  flex-shrink: 0;
}

.UserMenu_devLabel__e9CDx {
  flex: 1 1;
  text-align: left;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

/* La pastilla. Apagada va en gris neutro: en rojo se leería como un error. */
.UserMenu_switch__DUiNs {
  flex-shrink: 0;
  position: relative;
  width: 32px;
  height: 17px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--dylo-muted) 30%, transparent);
  border: 1px solid var(--dylo-field-border);
  transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}
.UserMenu_switchOn__CbIG7 {
  background: color-mix(in srgb, var(--matrix-green) 28%, transparent);
  border-color: color-mix(in srgb, var(--matrix-green) 65%, transparent);
  /* El resplandor es la señal de que está encendido incluso de reojo. */
  box-shadow: 0 0 8px color-mix(in srgb, var(--matrix-green) 40%, transparent);
}

/*
  La perilla se mueve con \`left\`, no con \`transform\`.

  Es un elemento en absoluto dentro de la pastilla, así que no participa del flujo y no
  puede empujar nada — la excepción que este proyecto ya tiene establecida para el
  desplazamiento animado.
*/
.UserMenu_knob__zEqJY {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: var(--dylo-muted);
  transition: left 0.2s cubic-bezier(0.22, 1, 0.36, 1), background-color 0.2s ease,
    box-shadow 0.2s ease;
}
.UserMenu_switchOn__CbIG7 .UserMenu_knob__zEqJY {
  left: 17px;
  background: var(--matrix-green);
  box-shadow: 0 0 6px var(--matrix-green);
}

@media (prefers-reduced-motion: reduce) {
  .UserMenu_switch__DUiNs,
  .UserMenu_knob__zEqJY {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/layout/UserMenu.module.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,qEAAqE;EACrE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,4CAA4C;EAC5C,mBAAmB;EACnB,2CAA2C;EAC3C,6BAA6B;EAC7B,gFAAgE;AAClE;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yEAAyE;AAC3E;AACA;;;;;;;EAOE;AACF;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gCAAgC;EAChC,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,qEAAqE;EACrE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mEAAmE;EACnE,yBAAyB;AAC3B;;AAEA;EACE,wBAAQ,eAAe,EAAE;EACzB,uDAAuB,gBAAgB,EAAE;AAC3C;;AAEA;;;;;wFAKwF;;AAExF;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qEAAqE;EACrE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,6EAA6E;AAC7E;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kEAAkE;EAClE,0CAA0C;EAC1C,oFAAoF;AACtF;AACA;EACE,oEAAoE;EACpE,sEAAsE;EACtE,sEAAsE;EACtE,4EAA4E;AAC9E;;AAEA;;;;;;CAMC;AACD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B;wBACsB;AACxB;AACA;EACE,UAAU;EACV,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["/* Trigger: sutil resaltado al abrir, sin el naranja de \"activo\" */\n.trigger {\n  border: none;\n  background: transparent;\n  text-align: left;\n  font-family: var(--font-sans);\n}\n.triggerOpen {\n  background: color-mix(in srgb, var(--dylo-teal-700) 12%, transparent);\n  color: var(--dylo-ink);\n}\n\n.menu {\n  position: fixed;\n  z-index: 1200;\n  width: 244px;\n  padding: 8px;\n  background: var(--dylo-surface);\n  border: 1px solid var(--dylo-surface-border);\n  border-radius: 14px;\n  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.28);\n  transform-origin: bottom left;\n  animation: user-menu-in 0.18s cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n\n@keyframes user-menu-in {\n  from { opacity: 0; transform: translateY(6px) scale(0.97); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.identity {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 8px 8px 10px;\n}\n.avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: var(--dylo-teal-700);\n  color: #fff;\n  font-family: var(--font-sans);\n  font-size: 14px;\n  font-weight: 700;\n}\n.identityText {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.name {\n  font-family: var(--font-sans);\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.email {\n  font-family: var(--font-sans);\n  font-size: 12px;\n  color: var(--dylo-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.divider {\n  height: 1px;\n  background: var(--dylo-line);\n  margin: 4px 4px 6px;\n}\n\n.action {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  width: 100%;\n  padding: 9px 10px;\n  border: none;\n  background: transparent;\n  color: var(--dylo-text);\n  font-family: var(--font-sans);\n  font-size: 13.5px;\n  font-weight: 500;\n  text-align: left;\n  border-radius: 9px;\n  cursor: pointer;\n  transition: background 0.14s ease, color 0.14s ease, transform 0.14s ease;\n}\n/*\n * Globo de novedades sin leer.\n *\n * 🔑 `margin-left: auto` lo empuja al borde derecho del renglón sin necesitar una rejilla: el resto del menú son\n * renglones de icono + texto, y meter una tercera columna solo por esto cambiaría los cuatro.\n *\n * ⚠️ Lleva NUMERO y no un punto: un punto no dice cuántas, y obliga a abrir para saber si vale la pena.\n */\n.badge {\n  margin-left: auto;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  background: var(--dylo-teal-700);\n  color: #fff;\n  font-size: 10.5px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.action svg {\n  flex-shrink: 0;\n  transition: transform 0.16s ease;\n}\n.action:hover {\n  background: color-mix(in srgb, var(--dylo-teal-700) 12%, transparent);\n  color: var(--dylo-ink);\n}\n.action:hover svg {\n  transform: scale(1.12);\n}\n.danger:hover {\n  background: color-mix(in srgb, var(--dylo-danger) 14%, transparent);\n  color: var(--dylo-danger);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .menu { animation: none; }\n  .action, .action svg { transition: none; }\n}\n\n/* ============================================================\n   Interruptor de la vista de Developer\n   ============================================================\n   Único renglón del menú con colores propios. No hereda el verde del bloque del\n   sidebar por accidente: se declara aquí porque el menú se dibuja en un **portal**\n   (`document.body`), así que está fuera del árbol de `.devBlock` y no heredaría nada. */\n\n.devToggle {\n  --matrix-green: #39ff88;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n}\n.devToggle svg {\n  color: var(--matrix-green);\n  flex-shrink: 0;\n}\n\n.devLabel {\n  flex: 1;\n  text-align: left;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 12px;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n/* La pastilla. Apagada va en gris neutro: en rojo se leería como un error. */\n.switch {\n  flex-shrink: 0;\n  position: relative;\n  width: 32px;\n  height: 17px;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--dylo-muted) 30%, transparent);\n  border: 1px solid var(--dylo-field-border);\n  transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n}\n.switchOn {\n  background: color-mix(in srgb, var(--matrix-green) 28%, transparent);\n  border-color: color-mix(in srgb, var(--matrix-green) 65%, transparent);\n  /* El resplandor es la señal de que está encendido incluso de reojo. */\n  box-shadow: 0 0 8px color-mix(in srgb, var(--matrix-green) 40%, transparent);\n}\n\n/*\n  La perilla se mueve con `left`, no con `transform`.\n\n  Es un elemento en absoluto dentro de la pastilla, así que no participa del flujo y no\n  puede empujar nada — la excepción que este proyecto ya tiene establecida para el\n  desplazamiento animado.\n*/\n.knob {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  background: var(--dylo-muted);\n  transition: left 0.2s cubic-bezier(0.22, 1, 0.36, 1), background-color 0.2s ease,\n    box-shadow 0.2s ease;\n}\n.switchOn .knob {\n  left: 17px;\n  background: var(--matrix-green);\n  box-shadow: 0 0 6px var(--matrix-green);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .switch,\n  .knob {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `UserMenu_trigger__O-RR4`,
	"triggerOpen": `UserMenu_triggerOpen__cQW7C`,
	"menu": `UserMenu_menu__NCb6M`,
	"user-menu-in": `UserMenu_user-menu-in__fPoiv`,
	"identity": `UserMenu_identity__5BqXd`,
	"avatar": `UserMenu_avatar__8lvQg`,
	"identityText": `UserMenu_identityText__4czOS`,
	"name": `UserMenu_name__HqhSc`,
	"email": `UserMenu_email__qYNcy`,
	"divider": `UserMenu_divider__e0mBG`,
	"action": `UserMenu_action__rWYOY`,
	"badge": `UserMenu_badge__4RTVQ`,
	"danger": `UserMenu_danger__2cLF9`,
	"devToggle": `UserMenu_devToggle__yGmvo`,
	"devLabel": `UserMenu_devLabel__e9CDx`,
	"switch": `UserMenu_switch__DUiNs`,
	"switchOn": `UserMenu_switchOn__CbIG7`,
	"knob": `UserMenu_knob__zEqJY`
};
export default ___CSS_LOADER_EXPORT___;
